




































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import { 
  ICurrentCustomerUserProfileDto, 
  IVcClaimSummaryLightDto, 
  IApplicantsTasksDto, 
  IRetrieveVcClaimsByUserInput, 
  RetrieveVcClaimsByUserInput,
  RetrieveMailItemInput,
  SearchMailItemInputforStaff,
  MailItemDto
} from '@/asdcom/apiproxy/apiproxy.dto';
import ApplicantRequestListComponent from "@/components/vcponlineok/applicant-request-list-component.vue";
import ClaimListComponent from "@/components/vcponlineok/claim-list-component.vue";
import ApplicantMailListComponent from "@/components/vcponlineok/applicant-mail-list-component.vue";

@Component({
  components: {
    ApplicantRequestListComponent,
    ClaimListComponent,
    ApplicantMailListComponent
  }
})
export default class OnlineUserComponent extends BaseComponent {
  userClaimList: IVcClaimSummaryLightDto[] = [];
  userRequestList: IApplicantsTasksDto[] = [];
  activeTab: number = 0;
  userMail: MailItemDto[] | undefined = [];
  isClaimListLoaded:boolean = false;
  isRequestListLoaded:boolean = false;
  
  @Prop({default: () => {}}) selectedProfile: ICurrentCustomerUserProfileDto;

  created() {
    this.loadClaims();
    if (this.$route.name == "ApplicantRequests") {
      this.onRequestsTabActivated();
      this.activeTab = 1;
    }
  }

  async loadClaims() {
    if (!!this.selectedProfile && !this.isClaimListLoaded) {
      const input: IRetrieveVcClaimsByUserInput = {
        userId: this.selectedProfile.userId as number
      };

      this.userClaimList = await this.$appsvs.vcpOnlineOkStaff.retrieveClaimsByUser(
        input as RetrieveVcClaimsByUserInput
      );
      this.isClaimListLoaded = true;
    }
  }

  private async onRequestsTabActivated() {
    if (!!this.selectedProfile && !this.isRequestListLoaded) {
      const ret = await this.$appsvs.vcpOnlineOkStaff.retrieveApplicantRequestsByUserId(
        this.selectedProfile.userId
      );
      if (!!ret.applicantsTasks) this.userRequestList = ret.applicantsTasks;
      this.isRequestListLoaded = true;
      // abp.log.debug({"online-users-view requests":this.userRequestList});
    }
  }

  private async onClaimsTabActivated() {
    this.loadClaims();
  }

  private async onVpBoxTabActivated() {

    const searchMailItemInput = new SearchMailItemInputforStaff({username: this.selectedProfile.userName});
    const ret = await this.$appsvs.staffVpBox.searchMailItems(searchMailItemInput);
    this.userMail = ret.items;
    
  }

  getAddressHtml(addr: any) {
    const formattedAddress = this.formatAddress(addr);
    let ret = null;
    if (!!formattedAddress) {
      ret = `<div>${formattedAddress.line1}</div><div>${formattedAddress.line2}</div>`;
    }
    return ret;
  }

  onUserProfileClose() {
    this.$emit("isDetailsVisible")
    /// clear loaded lists.
    this.userClaimList = [];
    this.userRequestList = [];
    this.userMail = [];
    this.isClaimListLoaded = false;
    this.isRequestListLoaded = false;
  }
}
